module.exports = __webpack_public_path__ + "img/828a7dc.png";